    <div *ngIf="product"
        class="ncp-container bg-layout rounded-corner-12"
        [ngClass]="{'multi': !isSingleProduct}"
        [ngStyle]="{'background-image': 'url(' + templateImage.background_image + ')'}">
    
        <div class="d-flex justify-content-between">
            <div class="header-container ellipsis" [ngClass]="{'w-50': !isSingleProduct}">
                <span class="paragraph-bold d-block ellipsis pb-2"
                    [ngStyle]="{'color': templateColor.text_color}"
                    [title]="templateText.banner_header_text">
                   {{templateText.banner_header_text}}
                </span>
                <div class="heading-container d-flex align-items-center justify-content-start mb-3">
                    <img loading="lazy" [src]="templateImage.icon" width="40"
                        class="brand-icon" alt="brand icon"/>
                    <span class="heading-3 pl-2"
                        [ngStyle]="{'color': templateColor.text_color}"
                        [title]="ncpProduct.title">
                        {{ncpProduct.title}}
                    </span>
                </div>
            </div>
            <div class="mt-2 mr-3 mb-4 ml-0 ncp-button"
                *ngIf="!isSingleProduct">
                <button class="btn-design small outline bg-transparent"
                    (click)="navigateToNcpDetail()"
                    [appAnalyticsEvent]="analyticsViewAllData"
                    [ngStyle]="{'color': templateColor.text_color}">
                    {{mls.languageText.ncp_card_screen.key6}}
                    <img width="18px" src="assets/themes/icons/white-arrow.svg"
                       alt="arrow" />
                </button>
            </div>
        </div>
        <ng-container *ngIf="isSingleProduct; else multiProduct">
            <app-game-card
                appear
                [horizontal]="true"
                [rootMargin]="fcs.margin.ncpCurrentHRootMargin"
                [appearIds]="getAppearedIds(ncpProducts[0])"
                (appearedCards)="onCardAppear($event)"
                [cardType]="cardTypeConst.SINGLE"
                [product]="ncpProducts[0]"
                [callingFrom]="callingFrom"
                [channel] = "ncpProduct?.channel">
            </app-game-card>
        </ng-container>
    
        <ng-template #multiProduct>
            <div class="custom-owl-carousel bg-transparent">
                <owl-carousel-o [options]="customOptions">
                  <ng-template carouselSlide *ngFor="let n_product of ncpProducts">
                    <div class="slide-container">
                        <app-game-card
                            appear
                            [horizontal]="true"
                            [rootMargin]="fcs.margin.ncpCurrentHRootMargin"
                            [appearIds]="getAppearedIds(n_product)"
                            (appearedCards)="onCardAppear($event)"
                            [cardType]="cardTypeConst.MULTI"
                            [product]="n_product"
                            [callingFrom]="screeName.NCP_HORIZONTAL_CAROUSEL"
                            [channel] = "ncpProduct?.channel">
                        </app-game-card>
                    </div>
                  </ng-template>
                </owl-carousel-o>
              </div>
        </ng-template>
    </div>